import { c as _c } from "react/compiler-runtime";
import { IcoFlag16, IcoPlusSmall16 } from '@onefootprint/icons';
import type { LabelKind } from '@onefootprint/request-types/dashboard';
import { Dropdown } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import useLabelText from '@/entity/hooks/use-label-text';
type TriggerProps = {
  value: LabelKind | undefined;
  disabled?: boolean;
};
export const Trigger = t0 => {
  const $ = _c(24);
  const {
    value,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "headerDefault.fraudLabel"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const labelT = useLabelText();
  const hasValue = value !== undefined;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !disabled;
  let t4;
  if ($[3] !== disabled || $[4] !== hasValue || $[5] !== t3) {
    t4 = cx("flex items-center h-6 pl-1.5 pr-2.5 transition-colors rounded-full bg-secondary w-fit", {
      "gap-1": hasValue,
      "opacity-50": disabled,
      "hover:bg-hover active:bg-senary": t3
    });
    $[3] = disabled;
    $[4] = hasValue;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== hasValue) {
    t5 = hasValue ? <IcoFlag16 color="primary" /> : <IcoPlusSmall16 color="primary" />;
    $[7] = hasValue;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== hasValue || $[10] !== labelT || $[11] !== t || $[12] !== value) {
    t6 = hasValue ? labelT(value) : t(_temp2);
    $[9] = hasValue;
    $[10] = labelT;
    $[11] = t;
    $[12] = value;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <p className="truncate text-caption-1 text-primary">{t6}</p>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <div className={t4}>{t5}{t7}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== disabled || $[21] !== t2 || $[22] !== t8) {
    t9 = <Dropdown.Trigger aria-label={t2} disabled={disabled}>{t8}</Dropdown.Trigger>;
    $[20] = disabled;
    $[21] = t2;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default Trigger;
function _temp($) {
  return $.addAriaLabel;
}
function _temp2($_0) {
  return $_0.addLabel;
}